export default function Menu() {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: '400',
        },
      },
    },
  };
}
